module.exports = __webpack_public_path__ + "static/media/goldenGateSideFoggy.be2c45cc.jpg";